module.exports = __webpack_public_path__ + "static/media/scrubber.36844e39.svg";